import React from 'react'
import './style.sass'
import PropTypes from 'prop-types'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

const FieldWrapper = ({ children, displayName, description, disabled, errorMessage }) => {

  const getFieldContainerClassName = () => {
    if (disabled) return "disabled-field-container"
    if (errorMessage) return "error-field-container"
  }
  
  const renderFieldDescriptionTooltip = () => {
    return (
      <OverlayTrigger
        key={`tool-tip-${displayName}`}
        placement="right"
        overlay={
          <Tooltip id={`tool-tip-${displayName}`}>
            {description}
          </Tooltip>
        }
      >
        <i className="fa fa-info-circle"/>
      </OverlayTrigger>
    )
  }

  return (
    <div className="field-wrapper-container">
      {!displayName || (
        <label className="field-label">
          {displayName} {' '}
          {!description || renderFieldDescriptionTooltip()}
        </label> 
      )} 
      <div className={getFieldContainerClassName()}>
        {children}
      </div>
      {!errorMessage || <label  className="field-error-text">{errorMessage}</label>}
    </div>
  )
}

FieldWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  displayName: PropTypes.string,
  disabled: PropTypes.bool,
  errorMessage: PropTypes.string
}

export default FieldWrapper
